import React from "react";
import ReactDOM from "react-dom/client";
import ClearViewMembershipManager from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<ClearViewMembershipManager />);